import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { api } from "./index.api";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import toastError from "../../components/notif";
import { SnackPractice } from "../../types/practice";

function practicesApiErrorHandler(error: FetchBaseQueryError) {
  switch (error.status) {
    default:
      toastError("unkown error please try again later");
  }
}

const practiceEntity = createEntityAdapter<SnackPractice, string>({
  selectId: (practice: SnackPractice) => practice._id,
});

const fileApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSnackPractices: builder.query<
      EntityState<SnackPractice, string>,
      {
        snackId: string;
      }
    >({
      query: (input) => `/snacks/${input.snackId}/practices`,
      transformResponse(baseQueryReturnValue, meta, arg) {
        return practiceEntity.addMany(
          practiceEntity.getInitialState(),
          baseQueryReturnValue as any
        );
      },
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          practicesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      providesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "practices",
            id: api.snackId,
          },
        ];
      },
    }),
    addSnackPractice: builder.mutation<
      void,
      { snackId: string; data: FormData }
    >({
      query: (input) => ({
        url: `/admin/snacks/${input.snackId}/practices`,
        method: "POST",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          practicesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "practices",
            id: api.snackId,
          },
        ];
      },
    }),

    updateSnackPractice: builder.mutation<
      void,
      { practiceId: string; snackId: string; data: FormData }
    >({
      query: (input) => ({
        url: `/admin/practices/${input.practiceId}`,
        method: "PUT",
        body: input.data,
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          practicesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "practices",
            id: api.snackId,
          },
        ];
      },
    }),

    deleteSnackPractice: builder.mutation<
      void,
      { practiceId: string; snackId: string }
    >({
      query: (input) => ({
        url: `/admin/practices/${input.practiceId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, api) {
        try {
          await api.queryFulfilled;
        } catch (error: any) {
          practicesApiErrorHandler(error.error as FetchBaseQueryError);
        }
      },
      invalidatesTags: (res, err, api) => {
        if (err) return [];
        return [
          {
            type: "practices",
            id: api.snackId,
          },
        ];
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSnackPracticesQuery,
  useAddSnackPracticeMutation,
  useUpdateSnackPracticeMutation,
  useDeleteSnackPracticeMutation,
} = fileApi;
